function changeNews(setIndex) {

    var currentIndex;
    var listItems = $('.m-offer, .m-slider__image');
    var listDots = $('.dots .dot');

    //automatic slider
    if (setIndex == null)
    {
        //slider item
        if($('.is-visible').next('.m-offer, .m-slider__image').length){
            $('.m-offer__container, .m-slider')
                .find('.is-visible')
                .removeClass('is-visible')
                .next('.m-offer, .m-slider__image')
                .addClass('is-visible');
        } else {
            $('.m-offer__container, .m-slider')
                .find('.is-visible')
                .removeClass('is-visible');

            $('.m-offer:first, .m-slider__image:first')
                .addClass('is-visible');
        }

        //dots
        currentIndex = listItems.index($('.is-visible'));
        listDots.removeClass('active');
        listDots.eq(currentIndex).addClass('active');

    }
    //manual selection
    else
    {
        currentIndex = setIndex;

        //slider item
        $('.m-offer, .m-slider__image').removeClass('is-visible');
        $('.m-offer').eq(currentIndex).addClass('is-visible');
        $('.m-slider__image').eq(currentIndex).addClass('is-visible');

        //dots
        $('.dots .dot').removeClass('active');
        $('.dots .dot').eq(currentIndex).addClass('active');
    }
}

$(function() {

    // Detect IE
    var userAgent = window.navigator.userAgent;
    var internetExplorer = userAgent.search(/(MSIE|Trident|Edge)/);
    var iOS = userAgent.search(/(iPod|iPhone)/);
    var interval;

    // make <div>s out of <img>s with object-fit
    if(internetExplorer > -1){
        $('.m-slider__image, .m-grid__image').each(function(){
            var $thisImage = $(this);
            var $thisSrc = $thisImage.attr('src');
            var $thisClasses = $thisImage.attr('class');
            $thisImage.after('<div class="'+$thisClasses+'" style="width:100%; height:100%; background-image: url('+$thisSrc+'); background-size: cover;"></div>')
            $thisImage.remove();
        });
    }

    if(internetExplorer > -1){
        $('.alignnone').each(function(){
            var $thisImage = $(this);
            var $thisSrc = $thisImage.attr('src');
            var $thisClasses = $thisImage.attr('class');
            $thisImage.after('<div class="'+$thisClasses+'" style="width:calc(25% - 1.25rem - 1px); height:75px; background-image: url('+$thisSrc+'); background-size: contain; background-position: center;"></div>')
            $thisImage.remove();
        });
    }

    if(internetExplorer > -1){
        $('.m-navigation__icon img').each(function(){
            var $thisImage = $(this);
            var $thisSrc = $thisImage.attr('src');
            var $thisClasses = $thisImage.attr('class');
            $thisImage.after('<div class="'+$thisClasses+'" style="width:100%; height:100%; background-image: url('+$thisSrc+'); background-position: center; background-repeat: no-repeat;"></div>')
            $thisImage.remove();
        });
    }

    /*if(iOS > -1) {

        $('.m-section--iframe').css('padding-top', '2rem');

        $('.m-iframe').each(function(){
            var $thisIframe = $(this).children();
            var $thisSrc = $thisIframe.attr('src');
            $thisIframe.after('<div class="m-iframe__notice"><p>Leider haben iOS Geräte ein Problem das Iframe richtig anzuzeigen. Bitte nutzen Sie diesen <a href="'+$thisSrc+'" class="">Link</a> um zu den Immobilien zu gelangen.</p></div>');
            $thisIframe.remove();
        })

    }*/

    /**
     *  News Slider
    */

    interval = setInterval(function(){
        changeNews();
    }, 6000);

    $('.dots .dot').on('click', function(event) {
        var list = $('.dots .dot');
        var index = list.index(this);
        clearInterval(interval);
        changeNews(index);
    });


    /**
     *  Navigation
     */

    $(window).scroll(function(){

        if ($(window).scrollTop() > 80) {

            $('.l-header').addClass('is-smaller')

        }

        else {

            $('.l-header').removeClass('is-smaller')

        }

    })

    $('.m-hamburger').on('click', function() {

        $('.m-hamburger').toggleClass('is-open');
        $('.l-nav').toggleClass('is-open');
        $('.m-menu--main').toggleClass('is-open');

    });


    $('.m-menu--main .menu-item-has-children > a').on('click', function(event) {
            event.preventDefault();
    });

    if ($('.m-menu--main').length) {

        if($('.menu-item-has-children').length) {

            $('.m-menu--main > .menu-item-has-children').addClass('link-disabled');

        }

    }

    if ($('.m-menu--main .current_page_parent').length) {

        $('.m-menu--main .current_page_parent > a').addClass('is-open');

    }

    $('body').on('click', '.m-menu--main .menu-item-has-children > a:not(.is-open)', function(){
        var $that = $(this);
        $('.m-menu--main .menu-item-has-children > a.is-open').not($that).removeClass('is-open').siblings('.sub-menu').slideUp();

        $that.addClass('is-open').siblings('.sub-menu').slideDown();
    }); 

    $('body').on('click', '.m-menu--main .menu-item-has-children > a.is-open', function(){

        $(this).removeClass('is-open').siblings('.sub-menu').slideUp();
    
    });

    /**
     * Fancybox
     */

    $('.m-grid__fancybox').fancybox({

    });

    /**
     * External link
     */

    var host = window.location.hostname;
    var domain = host.replace("www.", "");
    $('a[href^="http"]')
        .not('a[href*="' + domain + '"]')
        .attr("target", "_blank");

    $("a[href$='.pdf']").attr("target", "_blank")


    /**
     * Responsive
     */

    browserWidth = $(window).innerWidth();
    browserHeight = $(window).innerHeight();

    $(window).on('resize', function() {
        browserWidth = $(window).innerWidth();
        browserHeight = $(window).innerHeight();

        if ( browserWidth <= 900 ) {
            // Do something
        } else {
            // Do something
        }
    });

    /**
     *  Map
     */

    $('.m-map').each(function(){

        // create map
        new_map( $(this) );

    });


});




/*
 *  new_map
 *
 *  This function will render a Google Map onto the selected jQuery element
 *
 *  @type   function
 *  @date   8/11/2013
 *  @since  4.3.0
 *
 *  @param  $el (jQuery element)
 *  @return n/a
 */

function new_map( $el ) {

    // vars
    var args = {
        zoom        : 15,
        center      : new google.maps.LatLng(0, 0),
        mapTypeId   : 'satellite',
        //disableDefaultUI: true,
        scrollwheel : false
    };

    // create map
    var map = new google.maps.Map( $el[0], args);

    map.setTilt(0);

    // Change map to greyscale
    var mapstyle = [{"elementType": "geometry", "stylers": [{"color": "#f5f5f5"} ] }, {"elementType": "labels.icon", "stylers": [{"visibility": "off"} ] }, {"elementType": "labels.text.fill", "stylers": [{"color": "#616161"} ] }, {"elementType": "labels.text.stroke", "stylers": [{"color": "#f5f5f5"} ] }, {"featureType": "administrative.land_parcel", "elementType": "labels.text.fill", "stylers": [{"color": "#bdbdbd"} ] }, {"featureType": "poi", "elementType": "geometry", "stylers": [{"color": "#eeeeee"} ] }, {"featureType": "poi", "elementType": "labels.text.fill", "stylers": [{"color": "#757575"} ] }, {"featureType": "poi.park", "elementType": "geometry", "stylers": [{"color": "#e5e5e5"} ] }, {"featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"} ] }, {"featureType": "road", "elementType": "geometry", "stylers": [{"color": "#ffffff"} ] }, {"featureType": "road.arterial", "elementType": "labels.text.fill", "stylers": [{"color": "#757575"} ] }, {"featureType": "road.highway", "elementType": "geometry", "stylers": [{"color": "#dadada"} ] }, {"featureType": "road.highway", "elementType": "labels.text.fill", "stylers": [{"color": "#616161"} ] }, {"featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"} ] }, {"featureType": "transit.line", "elementType": "geometry", "stylers": [{"color": "#e5e5e5"} ] }, {"featureType": "transit.station", "elementType": "geometry", "stylers": [{"color": "#eeeeee"} ] }, {"featureType": "water", "elementType": "geometry", "stylers": [{"color": "#c9c9c9"} ] }, {"featureType": "water", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"} ] } ];
    map.setOptions({ styles: mapstyle });

    // add a markers reference
    map.markers = [];

    // add markers
    $el.each(function(){

        add_marker( $(this), map );

    });

    var parkfieldCoordinates = [
        {lat: 46.859675, lng: 9.519520},
        {lat: 46.859722, lng: 9.519493},
        {lat: 46.859811, lng: 9.519770}, 
        {lat: 46.859765, lng: 9.519800}, 

    ];

    var parkfieldPath = new google.maps.Polygon({
        paths: parkfieldCoordinates,
        strokeColor: 'rgb(0,0,0)',
        strokeOpacity: 1.0,
        strokeWeight: 2,
        fillColor: 'rgb(4,85,132)',
        fillOpacity: 0.35
    });

    parkfieldPath.setMap(map);


    // center map
    center_map( map );

    // return
    return map;

}

/*
 *  add_marker
 *
 *  This function will add a marker to the selected Google Map
 *
 *  @type   function
 *  @date   8/11/2013
 *  @since  4.3.0
 *
 *  @param  $marker (jQuery element)
 *  @param  map (Google Map object)
 *  @return n/a
 */

function add_marker( $marker, map ) {

    var image = {
        url: template_url + '/dist/images/mapmarker-blue.png',
        size: new google.maps.Size(54, 71),
        scaledSize: new google.maps.Size(54, 71), // IE needed
        anchor: new google.maps.Point(23, 63)
    };

    // var
    var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

    // create marker
    var marker = new google.maps.Marker({
        position    : latlng,
        map         : map,
        optimized   : false, // IE needed
        icon        : image
    });

    var icon = {
        url: '/app/themes/cmimmo_miux/dist/images/parkplatz.svg',
        size: new google.maps.Size(53, 49),
        origin: new google.maps.Point(0,0),
        anchor: new google.maps.Point(30,30),
        scaledSize: new google.maps.Size(43,39),
    }

    var parkfieldMarker = new google.maps.Marker({
        position    : new google.maps.LatLng(46.859777, 9.519635),
        map         : map,
        optimized   : false,
        icon        : icon,
    });

    // add to array
    map.markers.push( marker );

}

/*
 *  center_map
 *
 *  This function will center the map, showing all markers attached to this map
 *
 *  @type   function
 *  @date   8/11/2013
 *  @since  4.3.0
 *
 *  @param  map (Google Map object)
 *  @return n/a
 */

function center_map( map ) {

    // vars
    var bounds = new google.maps.LatLngBounds();

    // loop through all markers and create bounds
    $.each( map.markers, function( i, marker ){

        var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

        bounds.extend( latlng );

    });

    // only 1 marker?
    if( map.markers.length == 1 )
    {
        // set center of map
        map.setCenter( bounds.getCenter() );
        map.setZoom( 19 );
    }
    else
    {
        // fit to bounds
        map.fitBounds( bounds );
    }

}


// WEBPACK FOOTER //
// ./assets/scripts/main.js